export const DUE_IN_30_DAYS = "due_in_30_days";
export const DUE_IN_60_DAYS = "due_in_60_days";
export const DUE_IN_90_DAYS = "due_in_90_days";
export const CUSTOM = "CUSTOM";

export const DEADLINE_DATE_PERIODS = [
  { label: "Due in 30 days", value: DUE_IN_30_DAYS },
  { label: "Due in 60 days", value: DUE_IN_60_DAYS },
  { label: "Due in 90 days", value: DUE_IN_90_DAYS },
];

export const STATUS_OPTIONS = [
  { value: "PAYMENT_PENDING", label: "Payment pending" },
  { value: "ADD_DETAILS", label: "Add details" },
  { value: "PROCESSING", label: "Processing" },
  { value: "COMPLETED", label: "Completed" },
  { value: "AMENDMENT", label: "Amendment" },
  { value: "AMENDMENT_COMPLETED", label: "Amendment completed" },
  { value: "ARCHIVED", label: "Archived" },
];

export const STATUS_TAG_MAP: Record<
  string,
  { label: string; tagType: string }
> = {
  PAYMENT_PENDING: { label: "Payment pending", tagType: "orange" },
  ADD_DETAILS: { label: "Add details", tagType: "yellow" },
  PROCESSING: { label: "Processing", tagType: "blue" },
  COMPLETED: { label: "Completed", tagType: "green" },
  AMENDMENT: { label: "Amendment", tagType: "purple" },
  AMENDMENT_COMPLETED: { label: "Amendment completed", tagType: "green" },
  ARCHIVED: { label: "Archived", tagType: "gray" },
};

export const DEADLINE_STATUS_MAP: Record<
  string,
  { label: string; color: string }
> = {
  overdue: { label: "Overdue", color: "t-text-red" },
  critical: { label: "Due", color: "t-text-orange-80" },
  upcoming: { label: "Upcoming", color: "t-text-blue" },
};
